import { create } from "zustand";
import { devtools } from "zustand/middleware";

const usePaymentReconStore = create(
  devtools(
    (set, get) => ({
      // Documents state (shared across components)
      // Each document has: { docid, doctype, docno, docdate, amount, mode, remark, isSelected, showRemark }
      debitDocuments: [],
      creditDocuments: [],
      isLoadingDocs: false,

      // Document detail modal state
      detailModalOpen: false,
      selectedDocType: "",
      selectedDocId: null,

      // Actions - Documents
      setDebitDocuments: (docs) =>
        set({ debitDocuments: docs }, false, "set-debit-documents"),

      setCreditDocuments: (docs) =>
        set({ creditDocuments: docs }, false, "set-credit-documents"),

      setIsLoadingDocs: (loading) =>
        set({ isLoadingDocs: loading }, false, "set-is-loading-docs"),

      // Actions - Modal
      setDetailModalOpen: (isOpen) =>
        set({ detailModalOpen: isOpen }, false, "set-detail-modal-open"),

      setSelectedDocType: (docType) =>
        set({ selectedDocType: docType }, false, "set-selected-doc-type"),

      setSelectedDocId: (docId) =>
        set({ selectedDocId: docId }, false, "set-selected-doc-id"),

      openDetailModal: (docType, docId) =>
        set(
          {
            selectedDocType: docType,
            selectedDocId: docId,
            detailModalOpen: true,
          },
          false,
          "open-detail-modal"
        ),

      closeDetailModal: () =>
        set(
          {
            detailModalOpen: false,
            selectedDocType: "",
            selectedDocId: null,
          },
          false,
          "close-detail-modal"
        ),

      // Action - Toggle remark visibility for a document
      toggleRemarkVisibility: (docId, isDebit) =>
        set(
          (state) => {
            if (isDebit) {
              return {
                debitDocuments: state.debitDocuments.map(doc =>
                  doc.docid === docId ? { ...doc, showRemark: !doc.showRemark } : doc
                ),
              };
            } else {
              return {
                creditDocuments: state.creditDocuments.map(doc =>
                  doc.docid === docId ? { ...doc, showRemark: !doc.showRemark } : doc
                ),
              };
            }
          },
          false,
          "toggle-remark-visibility"
        ),

      // Action - Update document remark
      updateDocumentRemark: (docId, remark, isDebit) =>
        set(
          (state) => {
            if (isDebit) {
              return {
                debitDocuments: state.debitDocuments.map(doc =>
                  doc.docid === docId ? { ...doc, remark } : doc
                ),
              };
            } else {
              return {
                creditDocuments: state.creditDocuments.map(doc =>
                  doc.docid === docId ? { ...doc, remark } : doc
                ),
              };
            }
          },
          false,
          "update-document-remark"
        ),

      // Action - Update document amount
      updateDocumentAmount: (docId, amount, isDebit) =>
        set(
          (state) => {
            const parsedAmount = parseFloat(amount) || 0;
            
            if (isDebit) {
              return {
                debitDocuments: state.debitDocuments.map(doc =>
                  doc.docid === docId ? { ...doc, amount: parsedAmount } : doc
                ),
              };
            } else {
              return {
                creditDocuments: state.creditDocuments.map(doc =>
                  doc.docid === docId ? { ...doc, amount: parsedAmount } : doc
                ),
              };
            }
          },
          false,
          "update-document-amount"
        ),

      // Action - Toggle document selection
      toggleDocumentSelection: (docId, isDebit) =>
        set(
          (state) => {
            if (isDebit) {
              return {
                debitDocuments: state.debitDocuments.map(doc =>
                  doc.docid === docId ? { ...doc, isSelected: !doc.isSelected } : doc
                ),
              };
            } else {
              return {
                creditDocuments: state.creditDocuments.map(doc =>
                  doc.docid === docId ? { ...doc, isSelected: !doc.isSelected } : doc
                ),
              };
            }
          },
          false,
          "toggle-document-selection"
        ),

      // Action - Reset all state
      resetAllState: () =>
        set(
          {
            debitDocuments: [],
            creditDocuments: [],
            isLoadingDocs: false,
            detailModalOpen: false,
            selectedDocType: "",
            selectedDocId: null,
          },
          false,
          "reset-all-state"
        ),
    }),
    { name: "PaymentReconStore" }
  )
);

export default usePaymentReconStore;

